<template>
    <div class="loginPage">
      <HeaderTop :is_login="true"></HeaderTop>
      <div class="login-bannerbox">
        <img :src="tenantInfo.bannerImg" class="bannerbox-banner" alt="">
        <LoginBox @success="handleLoginSuccess"></LoginBox>
      </div>
      <!-- 通知公告 -->
      <div class="noticeBox">
        <div class="notice-container">
          <div class="notice-header">
            <div class="notice-title-wrapper">
              <img src="../assets/login/icon_notice.png" alt="" class="notice-icon">
              <h3 class="notice-title">通知公告</h3>
            </div>
            <a href="javascript:void(0)" class="more-link" @click="goNews('1')">更多 ></a>
          </div>
          <div class="notice-content">
            <span class="lineA"></span>
            <span class="lineB"></span>
            <div class="notice-grid">
              <div 
                v-for="(item, index) in noticeList" 
                :key="index" 
                class="notice-item"
                @click="goNewsDetail(item.id)"
              >
                <div class="notice-date-box">
                  <div class="date-day">{{ item.createDate.split(' ')[0].split('-')[2] }}</div>
                  <div class="date-month">{{ item.createDate.split(' ')[0].split('-')[0]+'-'+item.createDate.split(' ')[0].split('-')[1] }}</div>
                </div>
                <div class="notice-text">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻政策 -->
      <div class="newsPolicyBox">
        <div class="notice-container">
          <div class="notice-header">
            <div class="notice-title-wrapper">
              <img src="../assets/login/icon_news.png" alt="" class="notice-icon">
              <h3 class="notice-title">新闻政策</h3>
            </div>
            <a href="javascript:void(0)" class="more-link" @click="goNews('2')">更多 ></a>
          </div>
          <div class="news-policy-content">
            <div class="news-columns">
              <div class="news-column">
                <span class="line"></span>
                <div 
                  v-for="(item, index) in newsList" 
                  :key="index" 
                  class="news-item"
                  @click="goNewsDetail(item.id)"
                >
                  <h4 class="news-title">{{ item.title }}</h4>
                  <div class="news-meta">
                    <span class="news-date">{{ item.createDate }}</span>
                    <a href="javascript:void(0)" class="news-detail-link">查看详情 ></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="news-promo-box">
              <img src="../assets/login/news_promo.png" alt="" class="news-promo-img" />
            </div>
          </div>
        </div>
      </div>
      <!-- 报名流程 -->
      <div class="registrationProcessBox d-flex d-flex-middle d-flex-between">
        <div class="titleBox d-flex d-flex-center d-flex-middle">报名流程</div>
        <img src="../assets/login/icon_registration.png" alt="" class="registrationProcess-icon">
      </div>
      <!--  -->
      <Footer></Footer>
    </div>
  </template>
  
  <script>
  import vueQr from "vue-qr";
  // import SelectMajor from "@/components/SelectMajor";
  import HeaderTop from "@/components/HeaderTop.vue";
  import Footer from "@/components/Footer.vue";
  import { mapState } from "vuex"
  import LoginBox from "@/components/LoginBox.vue";
  
  export default {
    name: 'Login',
    components: {
      vueQr,
      // SelectMajor,
      HeaderTop,
      Footer,
      LoginBox
    },
    data() {
      return {
        loading: false,
        dialogVisible: false,
        intervalTime: null,
        smsSecond: 0,
        showCode: true, // 控制验证码显示
        user: undefined,
        activeIndex: 'Login',
        type: 0,
        noticeList: [],
        newsList: [],
      };
    },
    computed: {
      ...mapState(['tenantInfo'])
    },
    created() {
      localStorage.removeItem('login_choose')
    },
    mounted() {
      this.getList()
    },
    destroyed() {
      if (this.intervalTime) {
        clearInterval(this.intervalTime);
      }
    },
  
    methods: {
      getList(){
        this.$http.get('/student/pc/newIndex/info').then(res => {
          if(res){
            this.noticeList = res.newList1
            this.newsList = res.newList2
          }
        })
      },
      handleLoginSuccess() {
        this.$router.push({ path: "/main/home" });
      },
      goNews(type) {
        this.$router.push({ name: 'news', query: { type } })
      },
      goNewsDetail(id) {
        this.$router.push({
        path: './newsDetails',
        query:{
          id
        }
      })
      },
      verify() {
        this.$router.push({
          path: '/verify'
        })
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .loginPage {
    .login-bannerbox {
      position: relative;
      overflow: hidden;
      height: 580px;
      top: -30px;
      margin-bottom: -30px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bannerbox-banner{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      
      .loginBox {
        position: relative;
        z-index: 2;
        width: 1200px;
        max-width: 100%;
        padding: 0 20px;
        position: relative;
        top: 15px;
      }
    }

    .notice-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .notice-title-wrapper {
            display: flex;
            align-items: center;
            gap: 10px;

            .notice-icon {
              width: 22px;
              height: 20px;
            }

            .notice-title {
              font-size: 20px;
              font-weight: bold;
              color: #3E454D;
              margin: 0;
            }
          }

          .more-link {
            font-size: 14px;
            color: #999;
            text-decoration: none;
            cursor: pointer;
            transition: color 0.3s;

            &:hover {
              color: #666;
            }
          }
        }

    .noticeBox {
      width: 100%;
      background: #f5f5f5;
      padding: 40px 0;
      box-sizing: border-box;

      .notice-container {
        width: 1200px;
        margin: 0 auto;
        .notice-content {
          background: #fff;
          border-radius: 8px;
          padding: 10px 0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          position: relative;
          .lineA{
            position: absolute;
            top: 30px;
            left: 400px;
            width: 1px;
            height: calc(100% - 60px);
            background: #F3F3F3;
          }
          .lineB{
            position: absolute;
            top: 30px;
            right: 400px;
            width: 1px;
            height: calc(100% - 60px);
            background: #F3F3F3;
          }

          .notice-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0;

            .notice-item {
              width: 400px;
              display: flex;
              padding: 20px 30px;
              cursor: pointer;
              transition: background-color 0.3s;
              position: relative;
              
              &:nth-of-type(n+4) {
                &::after {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 30px;
                  width: calc(100% - 60px);
                  height: 1px;
                  background: rgba(0, 0, 0, 0.1);
                }
              }

              .notice-date-box {
                flex-shrink: 0;
                width: 60px;
                height: 50px;
                background: #EEF6FE;
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-right: 15px;

                .date-day {
                  font-size: 18px;
                  font-weight: bold;
                  color: #4084FF;
                  line-height: 1;
                  margin-bottom: 5px;
                }

                .date-month {
                  font-size: 12px;
                  color: #4084FF;
                  line-height: 1;
                }
              }

              .notice-text {
                flex: 1;
                font-size: 14px;
                color: #0B1D30;
                line-height: 1.6;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }

    .newsPolicyBox {
      width: 100%;
      background: #f5f5f5;
      padding: 0 0 40px 0;
      box-sizing: border-box;

      .notice-container {
        width: 1200px;
        margin: 0 auto;

        .news-policy-content {
          display: flex;
          gap: 20px;
          background: #fff;
          border-radius: 8px;

          .news-columns {
            display: flex;
            width: calc(100% - 350px);
            .news-column {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              position: relative;
              .line{
                position: absolute;
                top: 30px;
                left: 50%;
                width: 1px;
                height: calc(100% - 60px);
                background: #F3F3F3;
              }
              .news-item {
                width: 50%;
                box-sizing: border-box;
                padding: 30px;
                cursor: pointer;
                transition: opacity 0.3s;
                position: relative;
                &:nth-of-type(n+3){
                  &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 30px;
                    width: calc(100% - 60px);
                    height: 1px;
                    background: #F3F3F3;
                  }
                }

                .news-title {
                  font-size: 16px;
                  color: #1A1A1A;
                  margin: 0 0 12px 0;
                  height: 48px;
                  line-height: 24px;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .news-meta {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  .news-date {
                    font-size: 14px;
                    color: #767676;
                  }

                  .news-detail-link {
                    font-size: 14px;
                    color: #AAAAAA;
                    text-decoration: none;
                    transition: color 0.3s;

                    &:hover {
                      color: #666;
                    }
                  }
                }
              }
            }
          }

          .news-promo-box {
            width: 350px;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  
    .registrationProcessBox{
      background: #fff;
      border-radius: 5px;
      height: 130px;
      width: 1200px;
      margin: 0 auto 40px auto;
      .titleBox{
        background: #017BE3;
        box-sizing: border-box;
        padding: 30px 24px;
        height: 100%;
        font-size: 24px;
        color: #fff;
        font-weight: bold;
        border-radius: 5px 0 0 5px;
        width: 100px;
      }
      img{
        display: block;
        margin-right: 50px;
      }
    }
  }
  </style>
  